<template>
  <section>
    <qx-search-box
      class="searchBox"
      :searchBoxData="searchBoxData"
      @sub="sub"
      title="筛选"
      permpisionsQuery=""
    >
      <div slot="waitDeal" slot-scope="prop">
        <el-checkbox label="待我处理" name="type" v-model="prop.form.waitDeal" />
      </div>
    </qx-search-box>
    <TableBox ref="tableBox" />
  </section>
</template>

<script>
import TableBox from './tableBox';
import {
  getEnumList,
} from 'api';
export default {
  components: {
    TableBox,
  },
  data () {
    return {
      searchBoxData: {
        serviceTypeOptions: [], // 服务商类型
        authStateOptions: [], // 认证状态
        stateOptions: [], // 账号状态
        invitationStateOptions: [], // 审核状态
        form: [
          { // 待我处理
            label: '待我处理',
            value: 'waitDeal',
            default: true,
            slot: true,
          },
          { // 服务商账号
            label: '服务商账号',
            value: 'loginAcct',
            type: 'input',
            placeholder: '请输入服务商账号',
          },
          { // 服务商名称
            label: '服务商名称',
            value: 'serviceName',
            type: 'input',
            placeholder: '请输入服务商名称',
          },
          { // 联系人
            label: '联系人',
            value: 'linkman',
            type: 'input',
            placeholder: '请输入联系人',
          },
          { // 服务商类型
            label: '服务商类型',
            value: 'serviceType',
            type: 'select',
            default: -1,
            placeholder: '请选择服务商类型',
          },
          { // 认证状态
            label: '认证状态',
            value: 'authState',
            type: 'select',
            default: -1,
            placeholder: '请选择认证状态',
          },
          { // 账号状态
            label: '账号状态',
            value: 'state',
            type: 'select',
            default: -1,
            placeholder: '请选择账号状态',
          },
          { // 账号状态
            label: '审核状态',
            value: 'invitationState',
            type: 'select',
            default: -1,
            placeholder: '请选择服务商审核状态',
          },
        ],
      },
    };
  },
  methods: {

    /**
     * @param {object} searchBoxData 搜索栏数据
     * @returns {void}
     * @description 搜索栏触发搜索事件，将数据传递给表格box进行保存并刷新数据
     */
    sub (searchBoxData) {
      this.$refs.tableBox.saveSearchBoxData({
        status: -1,
        customerCode: '',
        companyName: '',
        customerName: '',
        ...searchBoxData,
      });
    },
  },
  async created () {
    const enumsList = await getEnumList({
      codeType: 'SYS_SERVICE_BUSI_TYPE,CUSTOMER_AUTH_STATE,SYS_STATE_DESC,INVITE_AUTH_STATE',
    });
    this.searchBoxData.serviceTypeOptions = [
      {
        label: '全部',
        value: -1,
      },
      ...enumsList[0],
    ];
    this.searchBoxData.authStateOptions = [
      {
        label: '全部',
        value: -1,
      },
      ...enumsList[1],
    ];
    this.searchBoxData.stateOptions = [
      {
        label: '全部',
        value: -1,
      },
      ...enumsList[2],
    ];
    this.searchBoxData.invitationStateOptions = [
      {
        label: '全部',
        value: -1,
      },
      ...enumsList[3],
    ];
  },
};
</script>

<style lang="scss" scoped>
</style>
